const ShareWorkAPI = (workId: string) => {
  return {
    SHARE_WORK: `/driver/${workId}/share`,
  };
};
export default ShareWorkAPI;
